import { Box, Flex, Image } from '@chakra-ui/react';

import './styles/alphanumeric-input.scss';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import AlphanumericInput from './AlphanumericInput';
import logo from '../../global/styles/images/launchdeck_logo.svg';
import { validateUrlFormat } from '../../global/helpers/global-helpers';

function DsrAccessCodeChallengeModule({
  teamLogos,
  processingAccessCode,
  showAccessCodeError,
  handleSubmitAccessCode,
  isMobileView,
  noLogoDisplay,
  dsrTitle
}) {

  function renderLogos() {

    if (noLogoDisplay) {
      return null
    } else {
      const { displayedHostLogo, displayedAudienceLogo } = teamLogos || {}

      // Todo: Make image appear only after they have loaded
      if (displayedHostLogo) {
        const showDisplauAudienceLogo = displayedAudienceLogo ? validateUrlFormat(displayedAudienceLogo) : false

        return (
          <Flex w='100%' justify='center' align='center' mb='2em' >
            <Image src={displayedHostLogo} alt="Host Logo" maxHeight='3em' />

            {showDisplauAudienceLogo &&
              <Flex align='center' >
                <Image src={displayedAudienceLogo} alt="" maxHeight='3em' />

              </Flex>}
          </Flex>
        )
      } else {
        return (
          <Flex w='100%' justify='center'>
            <Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='15em' maxHeight='3em' mb='2em' />
          </Flex>
        )
      }
    }
  }

  return (
    <Box bg='white' p='3em' rounded='0.25em' w={isMobileView && '90%'}>

      {renderLogos()}

      <Box minW='15em' maxW='35em'>
        {dsrTitle ?
          <Box textAlign='center' mb='3.5em'>
            <Box fontSize='1.1em' color='brandDark.500' fontWeight='600' lineHeight='1.375em'> {dsrTitle}</Box>

            <Box fontSize='0.8em' color='brandDark.500' fontWeight='400' lineHeight='1.375em' mt='0.2em'>
              Please provide the access code to enter</Box>


          </Box>
          :
          <Box textAlign='center' fontSize='0.875em' color='brandDark.500' fontWeight='400' lineHeight='1.375em' mb='3.5em'>
            This Room requires an access entry code provided by the Room Administrators</Box>
        }

        {processingAccessCode ?
          <PageLoader />
          :
          <AlphanumericInput defaultValue={''} errorLogic={showAccessCodeError} handleButtonClick={handleSubmitAccessCode} isMobileView={isMobileView} />
        }

        {dsrTitle &&
          <Box gap='0.25em' textAlign='center' fontSize='0.7em' color='gray.500' fontWeight='400' mt='1.5em' >
            <Box >No access code?</Box>
            <Box >Request it from your contact</Box>
          </Box>
        }
      </Box>
    </Box>
  )
}


export default DsrAccessCodeChallengeModule;